import React, { useState } from "react";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import { Accordion, AccordionDetails, AccordionSummary, Card, FormLabel, Grid } from "@mui/material";
import CardBody from "../../../../components/Card/CardBody";
import { useController } from "react-hook-form";
import { talenV5 } from "../../../../variables/app";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper";
import { ExpandMore } from "@mui/icons-material";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";

export default function General() {
  const [translationsInit, setTranslationsInit] = useState({});

  const {
    field: { value: translationsValue, onChange: translationsOnChange },
  } = useController({ name: "translations" });

  if (Object.keys(translationsInit).length === 0 && translationsValue != null) {
    setTranslationsInit(translationsValue);
  }

  return (
    <Card>
      <CardBody style={{ padding: 16 }}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <FormTextTC name={"name"} tDefault={"Name"} tKey={"packagingType.name"} />
            <FormSwitchTC defaultValue={true} name={"enabled"} tDefault={"Enabled"} tKey={"packagingType.enabled"} />
            <FormSwitchTC
              defaultValue={true}
              name={"order_mode_takeaway_enabled"}
              tDefault={"Enabled for Takeaway/Pickup (Kiosk / Webshop)"}
              tKey={"packagingType.order_mode_takeaway_enabled"}
            />
            <FormSwitchTC
              defaultValue={true}
              name={"order_mode_eat_in_enabled"}
              tDefault={"Enabled for Eat in (Kiosk)"}
              tKey={"packagingType.order_mode_eat_in_enabled"}
            />
            <FormSwitchTC
              defaultValue={true}
              name={"order_mode_delivery_enabled"}
              tDefault={"Enabled for Delivery (Webshop)"}
              tKey={"packagingType.order_mode_delivery_enabled"}
            />
          </Grid>
        </Grid>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMore />}>
            <TranslationWrapper tDefault={"Translations"} tKey={"Translations"} />
          </AccordionSummary>
          <AccordionDetails>
            {Object.keys(talenV5).map((objKey) => {
              let taal = talenV5[objKey];

              return (
                <FormTextTC
                  key={objKey}
                  label={
                    <FormLabel>
                      <TranslationWrapper tDefault={"Naam in"} tKey={"packagingType.form.vertalingennaam.label.naam"} />{" "}
                      <TranslationWrapper tDefault={taal.label} tKey={"global." + taal.transKey} />
                    </FormLabel>
                  }
                  name={"translations." + objKey + ".name"}
                />
              );
            })}
          </AccordionDetails>
        </Accordion>
      </CardBody>
    </Card>
  );
}
